/**
 * event Normalizr Schema
 */

import { schema } from 'normalizr';

import containerGroup from './containerGroup';
import harvestEvent from './harvestEvent';
import quantitySchedule from './quantitySchedule';

const event = new schema.Entity('events', {
    containerGroups: [containerGroup],
    harvestEvent,
    quantitySchedules: [quantitySchedule]
});

export default event;
